import { ReloadOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import type React from "react"
import { memo } from "react"

interface SystemVocabularyTableActionsProps {
  onRefresh: () => void
  loading?: boolean
}

const SystemVocabularyTableActions: React.FC<SystemVocabularyTableActionsProps> = memo(
  ({ onRefresh, loading = false }) => {
    return (
      <div className="flex grow items-center justify-end gap-2">
        <Tooltip title="Tải lại dữ liệu">
          <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
        </Tooltip>
      </div>
    )
  }
)

SystemVocabularyTableActions.displayName = "SystemVocabularyTableActions"

export default SystemVocabularyTableActions
